"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledMenu = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const helpers_1 = require("../helpers");
const styles_1 = require("../helpers/styles");
exports.StyledMenu = styled_components_1.default.div `
    box-sizing: border-box;
    outline: none;
    display: inline-block;

    white-space: nowrap;
    background-color: #fff;

    border-width: ${helpers_1.BASE_BORDER_WIDTH};
    border-style: solid;
    border-color: ${({ theme }) => theme.colorPopupBorderAccent};

    box-shadow: ${helpers_1.SHADOWS_NORMAL};

    min-width: 120px;
    max-height: 100%;
    overflow-y: auto;
    overflow-x: hidden;

    ${({ widthSize }) => widthSize &&
    (0, styled_components_1.css) `
            width: ${typeof widthSize === 'string' ? widthSize : (0, styles_1.calcWidth)(widthSize)};
        `}
`;
//# sourceMappingURL=Menu.styles.js.map